import html2canvas from "html2canvas";

export const captureElement = async (selector: string) => {
    const element = document.querySelector(selector) as HTMLElement;
    if (!element) {
        throw new Error(`Element with selector "${selector}" not found.`);
    }
    const canvas = await html2canvas(element);
    const dataURL = canvas.toDataURL("image/png");
    return dataURL;
};
